import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { SIZE } from '../../../constants/size'
import { useDateLocale } from '../../../hooks'
import { ConfirmationModal } from '../../Confirmation'
import { Skeleton } from '../../Skeleton'

import { QA_NAME_CALENDAR_FOLLOW_UP_CAP_MODAL } from './CalendarFollowUpCapModal.constants'
import {
  getCalendarFollowUpCapDescription,
  getCalendarFollowUpCapNextFreeDate,
  getHasCalendarFollowUpCapColleagues,
} from './CalendarFollowUpCapModal.utils'
import { ColleagueLoads } from './ColleagueLoads'
import { NextFreeDayButton } from './NextFreeDayButton'

import * as styles from './CalendarFollowUpCapModal.module.css'

function CalendarFollowUpCapModal({ cap, date, item, onClose, onMove }) {
  const { t } = useTranslation()

  const locale = useDateLocale()

  const [isMoving, setMoving] = useState(false)

  const nextFreeDate = getCalendarFollowUpCapNextFreeDate(cap)

  async function handleMove(nextDate) {
    setMoving(true)

    return onMove({ date: nextDate, item }).finally(() => {
      setMoving(false)
    })
  }

  async function handleSubmit() {
    return handleMove(date)
  }

  function handleMoveToNextFreeDate() {
    handleMove(nextFreeDate)
  }

  return (
    <ConfirmationModal
      actionButtonsProps={{
        children: (
          <NextFreeDayButton
            date={cap ? nextFreeDate : date}
            isLoading={isMoving}
            isSkeleton={!cap}
            onClick={handleMoveToNextFreeDate}
          />
        ),
        submitProps: { disabled: !cap },
        submitText: t('Calendar.CapProceedKey'),
      }}
      boxSize={SIZE.LARGE}
      description={
        cap ? (
          getCalendarFollowUpCapDescription({ cap, locale, t })
        ) : (
          <Skeleton Element='span' className={styles.skeleton} />
        )
      }
      loading={isMoving}
      qaName={QA_NAME_CALENDAR_FOLLOW_UP_CAP_MODAL}
      onCancel={onClose}
      onSubmit={handleSubmit}
    >
      {getHasCalendarFollowUpCapColleagues(cap) ? (
        <ColleagueLoads colleagues={cap.colleagues} />
      ) : null}
    </ConfirmationModal>
  )
}

export default CalendarFollowUpCapModal
